export default function Edge() {
    return (
        <div className="edge"></div>
    )
}
